import sanitizeHtml from 'sanitize-html';

// SYM-6558: a candidate's reply mail is put into the page as HTML. The API already cleans it
// (MailHtmlSanitizer); this is the second check, with the same allow-list, in the browser.
const MAIL_OPTIONS: sanitizeHtml.IOptions = {
  allowedTags: [
    'a',
    'b',
    'br',
    'div',
    'em',
    'i',
    'img',
    'li',
    'ol',
    'p',
    'span',
    'strong',
    'u',
    'ul',
  ],
  allowedAttributes: {
    a: ['href', 'target', 'style'],
    div: ['class', 'style'],
    img: ['src', 'alt', 'style', 'width', 'height'],
    li: ['style', 'value'],
    ol: ['style', 'start', 'reversed', 'type'],
    p: ['style'],
    span: ['class', 'style'],
    ul: ['style'],
  },
  // Any other class could borrow the app's own styling.
  allowedClasses: { div: ['gmail_inbodymedia'], span: ['gmail_inbodymedia'] },
  // Only the properties the API cleaner writes; values without brackets.
  allowedStyles: {
    '*': Object.fromEntries(
      [
        'color',
        'display',
        'height',
        'list-style-type',
        'margin-left',
        'max-width',
        'padding',
        'text-decoration',
        'word-break',
      ].map((property) => [property, [/^[#a-zA-Z0-9.%\s,-]{1,100}$/]])
    ),
  },
  allowedSchemes: ['http', 'https', 'mailto'],
  allowedSchemesByTag: { img: ['http', 'https', 'cid'] },
  allowProtocolRelative: false,
  // Unknown tags are unwrapped and their text kept, like on the server.
  disallowedTagsMode: 'discard',
};

export const sanitizeMailHtml = (html: string | undefined | null): string =>
  html ? sanitizeHtml(html, MAIL_OPTIONS) : '';

// Attachment names are file names: no markup at all, but entities stay as they are shown today.
export const sanitizeAttachmentName = (
  name: string | undefined | null
): string =>
  name ? sanitizeHtml(name, { allowedTags: [], allowedAttributes: {} }) : '';
